import { AppState } from './../../../store';

export const commonSelector = (state: AppState) => state.common;

export const commonDOJ = (state: AppState) => {
  return {
    doj: state.common.doj,
  };
};

export const contentSelector = (state: AppState) => {
  return {
    content: state.common.content,
  };
};

export const footerSelector = (state: AppState) => {
  return state.common.footer
};

export const routeStateSelector = (state: AppState) => {
  return { 
    srcState: state.common.srcState || '', destState: state.common.destState || ''
  }
}